export const replaceFontLink = (link?: string) => {
  return link?.replace('http://', 'https://');
};
